import {
	SecurityLiquidationPreferenceFormDto,
	SecurityLiquidationPreferenceShape,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/LiquidationPreference/liquidationPreference.zod.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import {
	SecurityInterestDefinitionPrincipal,
	SecurityLiquidationPreferenceRes,
} from '@dealstack/shared/lib/generated';

export enum LIQUIDATION_PREFERENCE_FORM_FIELD {
	principal = 'principal',
	principalValue = 'principalValue',
}

export const useLiquidationPreferenceController = (
	liquidationPreference: SecurityLiquidationPreferenceRes | null
) => {
	const tCapManage = useTranslationCapManage();

	const defaultValues = useMemo(
		() =>
			({
				principal:
					liquidationPreference?.principal ??
					SecurityInterestDefinitionPrincipal.ISSUE_COST_PER_UNIT,
				// Coerce null -> undefined: the LP res returns principalValue: null for
				// ISSUE_COST_PER_UNIT, but Mantine NumberInput throws on a null controlled value.
				principalValue: liquidationPreference?.principalValue ?? undefined,
			}) as SecurityLiquidationPreferenceFormDto,
		[liquidationPreference]
	);

	const liquidationPreferenceForm = useForm<SecurityLiquidationPreferenceFormDto>({
		mode: 'all',
		resolver: zodResolver(SecurityLiquidationPreferenceShape(tCapManage)),
		defaultValues,
		shouldFocusError: false,
	});

	const principal = liquidationPreferenceForm.watch(LIQUIDATION_PREFERENCE_FORM_FIELD.principal);

	useEffect(() => {
		if (principal === SecurityInterestDefinitionPrincipal.ISSUE_COST_PER_UNIT) {
			void liquidationPreferenceForm.trigger(
				LIQUIDATION_PREFERENCE_FORM_FIELD.principalValue
			);
		}
	}, [principal]);

	const resetForm = () => {
		liquidationPreferenceForm.reset(defaultValues);
	};

	return {
		liquidationPreferenceForm,
		resetForm,
	};
};
